module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel06_1280_1280_zh-hant-b2baeecaa4b7a8a6a409ef458da3130c.jpg";